<template>
  <div class="items-stretch justify-between hidden child-dropdown dropdown-menu current-exhibition-menu" id="menu-events" aria-labelledby="item-events">

    <span class="toggle-arrow"></span>

    <div class="grid grid-cols-2 events-list" aria-live="polite">
      <div class="col-span-1 row-span-1 row-start-1 cols-start-1">
        <p class="mb-8 hdg-4" id="event-menu-hdg">{{ displayDate() }}</p>
      </div>

      <div class="flex items-start justify-end col-span-1 row-span-1 row-start-1 cols-start-2">
        <a :href="eventsArchiveUrl" class="ml-7 btn-black-border">View All Events</a>
      </div>
      <div class="col-span-2 row-span-1 row-start-2 cols-start-">
        <template v-if="isRunning">

          <p>Loading events...</p>

        </template>
        <template v-else>

          <ul v-if="events.length > 0" class="row event-list__list" aria-labelledby="event-menu-hdg">
            <li v-for="(event, index) in events" :key="index" class="w-1/2 mb-10 col">
              <a :href="event.url" class="flex items-center justify-start hover:underline">
                <div class="relative flex-shrink-0 w-24 mr-5 image-wrapper aspect-square" v-html="event.image">
                </div>

                <div class="flex-initial">
                  <p class="mb-3 hdg-6" v-if="event.location">{{ event.location }}</p>
                  <p class="text-lg font-medium leading-snug text-gray-charcoal">{{ event.name }}</p>
                </div> <!-- /.flex-initial -->

              </a> <!-- /.flex -->
            </li> <!-- /.col -->
          </ul> <!-- /.row -->

          <template v-else>

            <p>No events for selected date.</p>

          </template>

        </template>
      </div>
    </div> <!-- /.events-list -->

  </div> <!-- /.dropdown-menu -->
</template>

<script>
export default {
  props: [ 'eventsArchiveUrl' ],
  data() {
    return {
      date: new Date(),
      todaysDate: null,
      events: [],
      isRunning: false,
    };
  },
  mounted() {
    const _this = this;
    _this.getEvents();
  },
  methods: {
    displayDate: function() {
      const _this = this;

      const nth = function(d) {
        if (d > 3 && d < 21) return 'th';
        switch (d % 10) {
          case 1:  return 'st';
          case 2:  return 'nd';
          case 3:  return 'rd';
          default: return 'th';
        }
      }

      const day = _this.date.getDate();
      const month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'][_this.date.getMonth()];

      if ( ! _this.todaysDate ) {
        _this.todaysDate = _this.date;
      }

      if ( _this.date.getTime() == _this.todaysDate.getTime() ) {
        return 'Today\'s Events, ' + month + ' ' + day + nth( day ) + ', ' + _this.date.getFullYear();
      } else {
        return 'Events on ' + month + ' ' + day + nth( day ) + ', ' + _this.date.getFullYear();
      }
    },
    getEvents: function() {
      const _this = this;

      if ( ! _this.isRunning ) {
        _this.isRunning = true;

        fetch( site_info.nav_events_url + '?date=' + _this.formatDate() )
          .then( function( response ) { return response.json(); } )
          .then( function( data ) {
            _this.events = data;
            _this.isRunning = false;
          } );
      }
    },
    formatDate: function() {
      const _this = this;
      let month = '' + (_this.date.getMonth() + 1);
      let day = '' + _this.date.getDate();
      const year = _this.date.getFullYear();

      if ( month.length < 2 ) {
        month = '0' + month;
      }

      if ( day.length < 2 ) {
        day = '0' + day;
      }

      return [year, month, day].join('-');
    },
  },
  watch: {
    date: function( newValue, oldValue ) {
      const _this = this;

      if ( _this.isRunning ) {
        _this.date = oldValue
      } else {
        _this.getEvents();
      }
    }
  },
  computed: {
  },
};
</script>
